import GoogleMap from "../utils/map";
import helpers from "../utils/helpers";
import selectric from "selectric";


const Contacts = {
  init() {
    this.events();

    const mapEl = $("#map-wrap");
    if (mapEl.length) {
      Contacts.renderMap(mapEl);
    }
    //container is undefined
    //const scrollTo = $("#form");
    //const position = scrollTo.offset().top - container.offset().top  + container.scrollTop();
    //container.animate({
      //scrollTop: position
    //});
  },

  events() {

    $('#file').change(function() {
      $('#fileLabel').text($('#file')[0].files[0].name);
      $('.drop-lable').css({ display : 'none' })
    });

    if ($("select").length) {
      $("select").selectric();
    }

    $("#contact-form").on("submit", (e) => {
      e.preventDefault();
      Contacts.validate();
    });

    $('.required').on('change', function (){
      $(this).removeClass('error')
      $(this).parent().parent().removeClass('row-w-error')
    })

    $('.terms-agreement').on('click', function (){
      $("#contact-form").find(".form-status").addClass("hidden");
    })
  },

  validate() {
    const formEl = $("#contact-form");

    if ( ! $('#agrChecked').is(':checked') ) {
      formEl.find(".form-status").removeClass("hidden");
      formEl
        .find(".form-status")
        .text('You must accept the terms of the agreement')
        .addClass("error");
      return false;
    }

    formEl.addClass("loading");

    $(".error", this).removeClass("error");

    if (helpers.validate(formEl)) {
      setTimeout(() => {
        Contacts.recaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
      const erInp = formEl.find(".error");
      erInp.toArray().forEach( input => {
        $(input).parent().parent().addClass("row-w-error")
      });
    }
  },

  recaptcha() {
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        Contacts.submit(token);
      });
    });
  },

  submit(token) {
    const formEl = $("#contact-form");

    const formData = new FormData(formEl[0]);

    // formData.append("file", $('input[type=file]')[0].files[0]);

    formData.append("token", token);

    formEl.find("button").addClass("loading");
    formEl.find(".form-status").addClass("hidden");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    })
      .done((response) => {
        if (response.success) {
          formEl[0].reset();
          $('#fileLabel').text('');
          $('.drop-lable').css({ display : 'flex' })
          formEl.find(".errors-wrap").remove();
          formEl.find(".form-status").removeClass("error");
        } else {
          formEl.find(".form-status").addClass("error");
        }

        formEl
          .find(".form-status")
          .text(response.data.message)
          .removeClass("hidden");
      })
      .always(() => {
        formEl.removeClass("loading");
        formEl.find("button").removeClass("loading");
      });
  },

  renderMap(mapEl) {

    function customZoomControl( map ){

      const zoomInButton = document.getElementById('zoomIn')

      const zoomOutButton = document.getElementById('zoomOut')

      google.maps.event.addDomListener(zoomInButton, 'click', function() {
        map.setZoom(map.getZoom() + 1);
      });

      google.maps.event.addDomListener(zoomOutButton, 'click', function() {
        map.setZoom(map.getZoom() - 1);
      });

    };

    const location = {
      lat: mapEl.data("lat"),
      lng: mapEl.data("lng"),
    };

    let zoom = parseInt(mapEl.data("zoom"));
    if (!zoom) {
      zoom = 16;
    }

    const pin = mapEl.data("pin");

    const map_options = {
      zoom,
      center: location,
      disableDefaultUI: true,
      zoomControl: false,
      styles: GoogleMap.styles,
    };

    const map = new google.maps.Map(mapEl[0], map_options);

    map.markers = [];

    const center = new google.maps.LatLng(location.lat, location.lng);

    // Marker and Icon.
    const marker_options = {
      position: center,
      clickable: false,
      map: map,
      animation: google.maps.Animation.DROP,
    };

    if (pin) {
      marker_options.icon = pin;
    } else {
      var icon = {
        size: new google.maps.Size(30, 40),
        path: "M15,40Q30,23.886,30,15.388A15.2,15.2,0,0,0,15,0,15.2,15.2,0,0,0,0,15.388Q0,23.886,15,40Z",
        fillColor: $(".header").css("background-color"),
        fillOpacity: 1,
        anchor: new google.maps.Point(15, 40),
        strokeWeight: 0,
        scale: 1,
      };
      marker_options.icon = icon;
    }

    const marker = new google.maps.Marker(marker_options);

    map.markers.push(marker);

    customZoomControl( map )

  },
};

export default Contacts;
